import { QueryCache, QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { PropsWithChildren } from 'react';

export const QueryWrapper = ({ children }: PropsWithChildren<any>) => {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: { networkMode: 'offlineFirst' },
      mutations: { networkMode: 'offlineFirst' },
    },
    queryCache: new QueryCache({
      onError(error, _query) {
        // TODO: do a global UI thing
        throw error;
      },
    }),
  });
  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
};
